<div class="driver-list" infiniteScroll [scrollWindow]="false" (scrolled)="onScrollDown()" [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="300">
  <span>
    @for (driver of overtimeDrivers; track driver.id; let i = $index) {
      <div class="driver-list__item"
        [ngClass]="{ 'driver-list__item--selected': selectedDriver.id === driver.id }" (click)="toggleDriverSelection(i)">
        <div class="driver-list__content">
          <app-avatar [imageSrc]="driver.profilePictureUrl!"
            [name]="driver.firstName + ' ' + driver.lastName"></app-avatar>
          <div class="driver-list__details d-flex flex-column gap-1">
            <span class="driver-list__details__name">{{ driver.firstName + ' ' + driver.lastName }}</span>
            <span class="driver-list__details__price">{{ formatCost(driver.totalCost) }}</span>
          </div>
        </div>
        @if (driver.hasPendingOvertime) {
          <div class="driver-list__status">
            <div class="driver-list__status__text">
              {{ 'overtimeManagement.details.requiresDecision' | transloco }}
            </div>
          </div>
        }
      </div>
    }
  </span>
  @if (driverListLoading) {
    <div class="spinner-overlay">
      <div class="d-flex align-items-center justify-content-center spinner-border"></div>
    </div>
  }
</div>